import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { AccountNameAndEmailForm } from "components/settings/account-name-and-email-form";

export const AccountNameAndEmailSettings = (props) => {
  const initialValues = R.pick(["emailPin", "label", "slug"], props);
  initialValues.emailPin = parseInt(initialValues.emailPin, 10);
  return (
    <div>
      <h1>Account Name and Email Address</h1>
      <h2>Account Name</h2>
      <AccountNameAndEmailForm
        emailPin={ props.emailPin }
        initialValues={ props }
        onSaveNameAndEmail={ props.onSaveNameAndEmail }
        slug={ props.slug }
      />
    </div>
  );
};

AccountNameAndEmailSettings.propTypes = {
  emailPin: PropTypes.string.isRequired,
  onSaveNameAndEmail: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/account-name-and-email-settings.jsx